module.exports = __webpack_public_path__ + "img/power-dev-4_2x.04eff86e.png";